import { uploadMedia } from '../repository/auth'
import moment from 'moment-timezone'
import store from '../Store/store'
import {environment} from '../env/environment'
import FileImg from '../assets/icons/file.png'
import VideoIcon from '../assets/icons/video.png'
import PDFIcon from '../assets/icons/pdf.png'
import ExcelIcon from '../assets/icons/excel.png'
import TextFileIcon from '../assets/icons/textfile.png'
const res = store.getState()?.auth

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1
    }
    if (b[orderBy] > a[orderBy]) {
        return 1
    }
    return 0
}

export function getComparator(order, orderBy) {
    return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy)
}

export function stableSort(array, comparator) {
    const stabilizedThis = array?.map((el, index) => [el, index])
    stabilizedThis?.sort((a, b) => {
        const order = comparator(a[0], b[0])
        if (order !== 0) {
            return order
        }
        return a[1] - b[1]
    })
    return stabilizedThis?.map((el) => el[0])
}

// This function is used to automatically scroll the page to the location where an error occurs.
export const scrollIntoViewHelper = (errors) => {
    const firstError = Object.keys(errors)[0]
    let el = document.querySelector(`[name="${firstError}"]`)
    if (el) {
        el.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
        })
    }
}
// upload media,photo,image
export let uploadLogo = async (event, type) => {
    let image = event.target.files[0]
    if (!image && !type) return
    const fd = new FormData()
    fd.append('image', image)
    fd.append('type', type)
    try {
        let response = await uploadMedia(fd)
        return response
    } catch (error) {
        return error
    }
}

export let uploadFile = async (image, type) => {
    if (!image && !type) return
    const fd = new FormData()
    fd.append('image', image)
    fd.append('type', type)
    try {
        let response = await uploadMedia(fd)
        return response
    } catch (error) {
        return error
    }
}

export const requiredMessage = (name) => {
    return `Please enter ${name}`
}
export const requiredSelect = (name) => {
    return `Please select ${name}`
}
export const requiredDate = (name) => {
    return `Please choose ${name}`
}

export const isEmpty = (value) => {
    if (typeof value === 'number') return value
    if (!value) return '--'
    return value?.length > 25 ? `${value.slice(0, 25)}...` : value
}

export const commonDateFormat = (date) => {
    return moment(date)?.tz(res?.user?.timeZone)?.format('DD-MM-YYYY')
}

export const isArray = (data, code) => {
    if (!data || data.length === 0) {
        return null // or return a default value or message
    }
    return (
        <ul className="p-0 m-0">
            {data.map((cur, index) => (
                <li key={index} style={{ listStyle: 'none' }}>
                    {cur[code]}
                </li>
            ))}
        </ul>
    )
}

export function capitalizeFirstLetter(str) {
    return str?.charAt(0).toUpperCase() + str?.slice(1)
}

// File Type function
export const fileType = (file, fileIndex = 0) => {
    let type = file?.split('.').pop()
    if (['png', 'jpeg', 'jpg'].includes(type)) {
        return (
            <>
                <img key={fileIndex} src={`${environment.baseURL}/${file}`} alt="" width="100%" height="100%" />
            </>
        )
    } else if (['mp4'].includes(type)) {
        return (
            <>
                <img key={fileIndex} src={VideoIcon} alt="" width="100%" height="100%" />
            </>
        )
    } else if (['pdf'].includes(type)) {
        return (
            <>
                <img key={fileIndex} src={PDFIcon} alt="" width="100%" height="100%" />
            </>
        )
    } else if (['xlsx', 'xls'].includes(type)) {
        return (
            <>
                <img key={fileIndex} src={ExcelIcon} alt="" width="100%" height="100%" />
            </>
        )
    } else if (['txt', 'doc'].includes(type)) {
        return (
            <>
                <img key={fileIndex} src={TextFileIcon} alt="" width="100%" height="100%" />
            </>
        )
    } else {
        return (
            <>
                <img key={fileIndex} src={FileImg} alt="" width="100%" height="100%" />
            </>
        )
    }
}

export function convertToTimezone(date = null, timezone, startOfDay = true) {
    let momentDate = moment(date)
    let year = momentDate.year()
    let month = momentDate.month()
    let day = momentDate.date()

    let hour = startOfDay ? 0 : 23
    let minute = startOfDay ? 0 : 59
    let second = startOfDay ? 0 : 59

    return moment.tz(timezone).set({ year, month, date: day, hour, minute, second }).utc()
}

export const paymentSummary = (paymentData) => {
    let paymentObj = {
        totalChargeAmount: 0,
        totalAllowedAmount: 0,
        totalInsurancePayment: 0,
        totalPatientResponsibility: 0,
        totalSecondaryDues: 0,
        totalPatientPaid: 0,
        totalPatientAllocated: 0,
        totalPatientUnAllocated: 0,
        totalRemainingBalance: 0,
        totalPatientBalanceDue: 0,
    }

    paymentObj.totalChargeAmount = Number(paymentData?.totalChargeAmount) || 0
    paymentObj.totalAllowedAmount = Number(paymentData?.totalAllowedAmount) || 0
    paymentObj.totalInsurancePayment = Number(paymentData?.totalInsurancePayment) || 0
    paymentObj.totalPatientBalanceDue = Number(paymentData?.totalPatientBalanceDue) || 0
    paymentObj.totalPatientPaid = Number(paymentData?.totalPatientPaid) || 0
    paymentObj.totalPatientAllocated = Number(paymentData?.totalPatientAllocated) || 0
    paymentObj.totalSecondaryDues = Number(paymentData?.totalSecondaryDues) || 0
    paymentObj.totalPatientUnAllocated = Number(paymentData?.totalPatientUnAllocated) || 0
    paymentObj.totalPatientResponsibility = Number(paymentData?.totalPatientResponsibility) || 0
    return paymentObj
}
